import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { FigmaToHtml } from '../app-setting/figmaConfig/FigmaToHtml';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class FigmaSection extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { match, actions, homeActions, plugin } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    homeActions.loadInstalledPlugin({ projectId, version });
  }

  render() {
    const { appSetting, match, actions, home } = this.props;
    const { projectDetail } = appSetting;
    const { projectId, version } = match.params;
    if (!projectDetail) {
      return '';
    }
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'section'} projectDetail={projectDetail} />
        <FigmaToHtml
          fetchFigmatoken={actions.fetchFigmatoken}
          fetchFigmaData={actions.fetchFigmaData}
          fetchFigmaImage={actions.fetchFigmaImage}
          projectDetail={projectDetail}
          iPlugins={home.iPlugins}
          projectId={projectId}
          version={version}
          deleteFigmaToHtmlData={actions.deleteFigmaToHtmlData}
          deleteFigmaTokenDetails={actions.deleteFigmaTokenDetails}
          fetchFigmaToHtmlData={actions.fetchFigmaToHtmlData}
          generateFigmaToHtml={actions.generateFigmaToHtml}
          isReadOnly={isReadOnly}
        ></FigmaToHtml>
      </CommonPageComponent>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FigmaSection);
